// EN
export const derivedRatesSection = {
  title: "Derived rates",
  description:
    "Create rates based on your main rate plans to connect with different OTAs while keeping a centralized base price.",
  newRate: "New derived rate",
  loading: "Loading rates...",

  otaBadge: "OTA",
  otaLockedTitle: "OTA rate: managed from 'Connect OTA'",
  salePaused: "Sales paused",

  columns: {
    name: "Name",
    adjustment: "Adjustment",
    finalPrice: "Final price",
  },

  actions: {
    resumeTitle: "Resume sales on Channex",
    pauseTitle: "Pause sales on Channex (stop_sell)",
    edit: "Edit",
    delete: "Delete",
    protectedTitle: "Protected: change or remove it from 'Connect OTA'",
  },

  empty: {
    title: "No derived rates",
    text: "Create derived rates based on your main rate plans to connect with OTAs",
    create: "Create first derived rate",
  },

  modal: {
    editTitle: "Edit derived rate",
    createTitle: "New derived rate",
    baseRatePlan: "Base rate plan",
    selectBasePlaceholder: "Select a base rate plan",
    selectBaseHint:
      "Select the rate plan this derived rate will be calculated from",
    nameLabel: "Derived rate name",
    namePlaceholder: "e.g. Booking.com rate, Airbnb rate",
    nameHint: "This name will help you identify the rate when connecting with OTAs",
    adjustmentType: "Adjustment type",
    percentage: "Percentage",
    fixedAmount: "Fixed amount",
    adjustmentValue: "Adjustment value",
    adjustmentValueHint: "(use negative values for discounts)",
    cancel: "Cancel",
    saving: "Saving...",
    update: "Update",
    create: "Create rate",
  },

  preview: {
    title: "Preview",
    basePrice: "Base price",
    increment: "Increase",
    discount: "Discount",
    finalPrice: "Final price",
  },

  delete: {
    title: "Delete derived rate",
    warnStrong: "This action can't be undone.",
    warnText:
      "Before deleting, make sure the rate {name} isn't linked to any OTA.",
    confirmLabel: "Type the exact name to confirm:",
    confirmPlaceholder: "Type the rate name exactly",
    confirmHint:
      "Paste or type the name exactly as shown above to enable the delete button.",
    cancel: "Cancel",
    processing: "Deleting...",
    confirm: "Delete permanently",
  },

  pause: {
    resumeTitle: "Resume sales",
    pauseTitle: "Pause sales",
    resumeText:
      "{code} will be sent to Channex for the next 500 days. The channel will start receiving availability again and can accept bookings.",
    pauseText:
      "{code} will be sent to Channex for the next 500 days. The channel linked to this rate won't be able to accept new bookings while paused.",
    note: "The main calendar and other channels won't be affected. To resume, click the ▶ button on the rate.",
    cancel: "Cancel",
    resuming: "Resuming...",
    pausing: "Pausing...",
    confirmResume: "Yes, resume sales",
    confirmPause: "Yes, pause sales",
  },

  toast: {
    loadError: "Error loading data",
    fillRequired: "Please complete all required fields",
    updated: "Rate updated successfully",
    created: "Rate created successfully",
    saveFailed: "Could not save the rate",
    saveError: "Error saving the derived rate",
    deleted: "Derived rate deleted",
    deleteFailed: "Could not delete the rate",
    deleteLinkedOta: "Can't delete: the rate is linked to an OTA.",
    nameMismatch: "The name entered doesn't match.",
    deleteError: "Error deleting the derived rate",
    salesPaused: "Sales paused",
    salesResumed: "Sales resumed",
    toggleFailed: "Could not change the status",
    toggleError: "Error changing the rate status",
    // Guardada en local, pero Channex no aceptó el cambio (channex_synced:false).
    channexNotSynced: "The rate was saved, but the channel manager didn't accept the change: your channels still have the previous version. Check the details and try again.",
  },

  // Estancia mínima propia de una derivada (own_min_stay). Campo y chip
  // compartidos: OwnMinStayField.vue / OwnMinStayChip.vue.
  ownMinStay: {
    label: "Own minimum stay (nights)",
    hint: "Empty = same as the main rate",
    mixedPlaceholder: "Various",
    mixedHint: "Each room has a different minimum. If you type one, it will apply to all of them; if you leave it empty, each keeps its own.",
    // Sugerencia por el nombre («Tarifa semanal» → 7): una pregunta de un clic.
    suggestQuestion: "Minimum {n} night? | Minimum {n} nights?",
    suggestUse: "Use",
    clear: "Remove",
    channelNote: "{channel} will receive a minimum of {n} night for this rate. | {channel} will receive a minimum of {n} nights for this rate.",
    genericNote: "Connected channels (Booking, etc.) will receive a minimum of {n} night for this rate. | Connected channels (Booking, etc.) will receive a minimum of {n} nights for this rate.",
    chip: "Min. {n} night | Min. {n} nights",
    chipMixed: "Min. differs per room",
    chipTitle: "This rate's own minimum stay: it is sent to the connected channels",
    // Grupo con mínimos distintos: quitárselo a todas es un gesto aparte.
    clearAll: "Remove the minimum from all",
    clearedAllHint: "When you save, all of them will lose their own minimum and use the main rate's.",
    undo: "Undo",
  },
};
